<div id="id_dod_popup{{_issue.id}}" *ngIf="definitionOfDones && taskDods" class="popupdod mat-card" [attr.data-userstoryid]="issue.parentIssueId">

  <!--Titel-->
  <mat-card-header *ngIf="!loadedFromIssue">
    <mat-card-title>DoD {{this.issue?.summary}}</mat-card-title>
  </mat-card-header>

  <!--Body-->
  <mat-card-content>
    <div class="action-item-accepted-content">
      <ul class="list-popup">
        <li>
          <label class="done table-header">Done</label>
          <label class="not-relevant table-header">Not relevant</label>
        </li>
        <li *ngFor="let dod of definitionOfDones">
          <mat-checkbox [checked]="isActiveSet(dod)" (change)="onTaskDodChanged(dod)" [disabled]="checkDisabled(dod)"
                        id="checkbox-id-{{_issue.id}}-{{dod.id}}" class="checkbox-space" color="primary">
          </mat-checkbox>
          <mat-checkbox [checked]="isRelevantSet(dod)" (change)="relevantChanged(dod)"
                        id="relevant-checkbox-id-{{_issue.id}}-{{dod.id}}" class="not-relevant">
          </mat-checkbox>
          <label class="dod-name">
            {{dod.name}}
          </label>
        </li>
      </ul>
    </div>
  </mat-card-content>

  <mat-card-footer *ngIf="!loadedFromIssue">
    <div class="footer-buttons">
      <button mat-raised-button (click)="saveChanges()">
        <mat-icon>done</mat-icon>
      </button>
    </div>
  </mat-card-footer>

</div>
